import { googleAnalyticsConfig } from '../../../config/googleAnalyticsConfig';
import { isProdEnvironment } from '../../../interfaces/environment/Environment';
import { getWindow } from '../../../services/windowService';
import { callIfFunction } from '../../../utils/callIfFunction';

const wnd = getWindow();

export const GA_SCRIPT_TAG_ID = 'google-analytics';
// https://analytics.google.com/analytics/web/?authuser=2#/a49923793p274951988/admin/datapolicies/datafilters
const traffic_type = isProdEnvironment() ? undefined : 'internal';

export const ensureGAScriptAdded = (callback?: (value: boolean) => void) => {
  if (document.getElementById(GA_SCRIPT_TAG_ID)) {
    callIfFunction(callback, true);
    return;
  }
  if (!googleAnalyticsConfig.gaMeasurementId) {
    callIfFunction(callback, false);
    return;
  }
  const script = document.createElement('script');
  script.id = GA_SCRIPT_TAG_ID;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsConfig.gaMeasurementId}`;
  script.async = true;
  script.onload = () => {
    setTimeout(() => {
      wnd.dataLayer = wnd.dataLayer || [];
      wnd.gtag = wnd.gtag = function () {
        wnd.dataLayer.push(arguments);
      };
      wnd.gtag('js', new Date());
      const opts: Record<string, any> = {
        send_page_view: false,
        traffic_type,
      };
      if (googleAnalyticsConfig.debugMode === 'true') {
        opts.debug_mode = true;
      }
      wnd.gtag('config', googleAnalyticsConfig.gaMeasurementId, opts);
      console.log(
        `GA enabled for "${googleAnalyticsConfig.gaMeasurementId}": ${JSON.stringify(opts)}`,
      );
      callIfFunction(callback, true);
    }, 0);
  };
  document.body.appendChild(script);
};
